import React from 'react'
import classNames from 'classnames'

import { ReactComponent as ProcessDocumentUploadIcon } from '../../../assets/images/process-document-upload-icon.svg'

import { useProcessDocumentFileInput } from '../../ProcessDocument/hooks'

import '../../ProcessDocument/ProcessDocumentFileInput/ProcessDocumentFileInput.scss'

const _SUPPORTED_MIME_TYPES = ['application/pdf']

interface FormTemplateFileInputProps {
  onFilesSelected: (files: File[]) => Promise<void>
}

export const FormTemplateFileInput: React.FC<FormTemplateFileInputProps> = ({ onFilesSelected }) => {
  const { isHovering, handleChange, handleDragEnter, handleDragLeave, handleDragOver, handleDrop } = useProcessDocumentFileInput(
    _SUPPORTED_MIME_TYPES,
    onFilesSelected,
  )

  return (
    <>
      <input id='process-document-file-input' type='file' accept={_SUPPORTED_MIME_TYPES.join(',')} onChange={handleChange} hidden={true} />
      <label
        htmlFor='process-document-file-input'
        className={classNames(
          'd-flex flex-column align-items-center justify-content-center zocks-gap-1 zocks-py-3.0 rounded-3 zocks-border-dashed zocks-bg-color-gray-100 process-document-file-input-label',
          {
            'process-document-file-input-label-hovering': isHovering,
          },
        )}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
      >
        <ProcessDocumentUploadIcon />
        <div className='d-flex flex-column align-items-center zocks-gap-0.25'>
          <span className='paragraph-medium bold zocks-text-gray-900'>Drop your file here or click to browse</span>
          <span className='paragraph-small zocks-text-gray-700'>Only PDF files up to 20 MB</span>
        </div>
      </label>
    </>
  )
}
